import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { TypedForm } from '@models/support/interfaces';
import { ISourceItemData } from '@se/models';

export interface ISelectTemplateDialogDataProps {
    message: string;
    body?: string;
    cancelLabel?: string;
    confirmLabel?: string;
    panelClass?: string;
    confirmOnEnter?: boolean;
    templates: ISourceItemData[];
}

@Component({
    selector: 'se-select-template-dialog',
    templateUrl: './se-select-template-dialog.component.html',
    styleUrls: ['./se-select-template-dialog.component.scss'],
    standalone: false,
})
export class SeSelectTemplateDialogComponent implements OnInit {
    confirmLabel = 'PrintModules';
    cancelLabel = 'Cancel';

    form: FormGroup<TypedForm<Record<string, string>>> | null = null;

    constructor(
        private dialogRef: MatDialogRef<ISelectTemplateDialogDataProps, string | null>,
        @Inject(MAT_DIALOG_DATA) public data: ISelectTemplateDialogDataProps,
    ) {
        this.confirmLabel = this.data.confirmLabel ?? this.confirmLabel;
        this.cancelLabel = this.data.cancelLabel ?? this.cancelLabel;
    }

    ngOnInit(): void {
        this.form = new FormGroup<TypedForm<Record<string, string>>>({
            template: new FormControl<string>('', {
                nonNullable: true,
                validators: [Validators.required],
            }),
        });

        const classesToAdd: string[] = ['se-assign-equipment-dialog'];
        if (this.data.panelClass) classesToAdd.push(this.data.panelClass);
        this.dialogRef.addPanelClass(classesToAdd);
    }

    confirm() {
        if (this.form && this.form.valid) this.dialogRef.close(this.form.get('template')?.value ?? '');
    }

    closeDialog() {
        this.dialogRef.close(null);
    }
}
